import { boot } from "@kit/boot";
import { t } from "./i18n";
import { game } from "./index";

boot({ id: game.meta.id, scenes: game.scenes, instructions: t("instructions") });
